import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Result, Button } from 'antd';
import { AuthProvider } from './contexts/AuthContext.js';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import PublicRoute from './components/PublicRoute.jsx';
import AdminLayout from './layouts/AdminLayout.jsx';
import PublicLayout from './layouts/PublicLayout.jsx';
import Main from './pages/Main.jsx';
import Login from './pages/Login.jsx';
import Register from './pages/Register.jsx';
import Enter from './pages/Enter.jsx';
import News from './pages/News.jsx';
import Dashboard from './pages/Dashboard.jsx';
import ClientDashboard from './pages/ClientDashboard.jsx';
import ClientProfile from './pages/ClientProfile.jsx';
import ProductDetail from './pages/ProductDetail.jsx';
import Profile from './pages/Profile.jsx';
import Settings from './pages/Settings.jsx';
import Mailings from './pages/Mailings.jsx';
import AccountDeletions from './pages/AccountDeletions.jsx';
import ProductsNew from './pages/ProductsNew.jsx';
import Clients from './pages/Clients.jsx';
import Unauthorized from './pages/Unauthorized.jsx';
import Forbidden from './pages/Forbidden.jsx';
import OfferAgreement from './pages/OfferAgreement.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import ForgotPassword from './pages/ForgotPassword.jsx';
import ResetPassword from './pages/ResetPassword.jsx';
import ConfirmDeletion from './pages/ConfirmDeletion.jsx';
import SupportButton from './components/SupportButton.jsx';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <SupportButton />
          <Routes>
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />

            <Route element={<AdminLayout />}>
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute requiredModule="dashboard">
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute requiredModule="admin">
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mailings"
                element={
                  <ProtectedRoute requiredModule="admin">
                    <Mailings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account-deletions"
                element={
                  <ProtectedRoute requiredModule="admin">
                    <AccountDeletions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/products"
                element={
                  <ProtectedRoute>
                    <ProductsNew />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients"
                element={
                  <ProtectedRoute>
                    <Clients />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tickets/:id"
                element={
                  <ProtectedRoute>
                    <Clients />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients/:id"
                element={
                  <ProtectedRoute>
                    <Clients />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/products/:id"
                element={
                  <ProtectedRoute>
                    <Clients />
                  </ProtectedRoute>
                }
              />
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="/forbidden" element={<Forbidden />} />
            </Route>

            <Route element={<PublicLayout />}>
              <Route
                path="/register"
                element={
                  <PublicRoute>
                    <Register />
                  </PublicRoute>
                }
              />
              <Route
                path="/forgot-password"
                element={
                  <PublicRoute>
                    <ForgotPassword />
                  </PublicRoute>
                }
              />
              <Route path="/reset-password" element={
                  <PublicRoute>
                    <ResetPassword />
                  </PublicRoute>
                }
              />
              <Route path="/confirm-deletion" element={<ConfirmDeletion />} />
              <Route path="/enter" element={<Enter />} />
              <Route path="/cabinet" element={<ClientDashboard />} />
              <Route path="/cabinet/profile" element={<ClientProfile />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/news" element={<News />} />
              <Route path="/offer-agreement" element={<OfferAgreement />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/" element={<Main />} />
              <Route
                path="*"
                element={
                  <Result
                    status="404"
                    title="404"
                    subTitle="Страница не найдена"
                    extra={
                      <Button type="primary" onClick={() => window.history.back()}>
                        Назад
                      </Button>
                    }
                  />
                }
              />
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
